export async function bootstrapApplication(loadConfig, loadApplication) {
  await loadConfig();
  return loadApplication();
}
